import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, concatAll, toArray } from 'rxjs/operators';

export interface EntityHistoryItem {
    id?: string;
    action?: string;
    description?: string;
    createdAt?: string;
    user?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    userEmail?: string;
    referentFirstName?: string;
    referentLastName?: string;
    referentEmail?: string;
    referent?: {
        firstName?: string;
        lastName?: string;
        email?: string;
    };
}

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';

import { User, DomainUser } from './models/back';
import { EntitiesMiscApiService } from '../api/entities-misc-api.service';

@Injectable({
    providedIn: 'root'
})
export class EntitiesMiscDomainService extends BaseMiscDomainService
{
    constructor (
        private entitiesMiscApiService: EntitiesMiscApiService
    )
    {
        super();
    }

    getReptUsers (entityId: string): Observable<User[]>
    {
        return this.entitiesMiscApiService.getReptUsers(entityId)
            .pipe(
                concatAll(),
                map(DomainUser.mapperFromApi),
                toArray()
            );
    }

    getHistory (entityId: string): Observable<EntityHistoryItem[]>
    {
        return this.entitiesMiscApiService.getHistory(entityId)
            .pipe(
                map((history: any) =>
                {
                    if (Array.isArray(history))
                    {
                        return history as EntityHistoryItem[];
                    }

                    if (history && Array.isArray(history.history))
                    {
                        return history.history as EntityHistoryItem[];
                    }

                    return [];
                })
            );
    }
}
